import View from './Reports.view';

export default View;
